import { Container, Box, Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import VerifiedIcon from '@mui/icons-material/Verified';
export default function Footer() {
    return (
        <>
            <footer
                style={{
                    background: '#0a1229',
                    marginTop: '80px',
                    paddingTop: '48px',
                }}
            >
                <Container>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'row' },
                            justifyContent: 'space-between',
                            p: 2,
                        }}
                    >
                        <Box
                            sx={{
                                flex: 1,
                                m: 1,
                                p: 2,
                            }}
                        >
                            <Link
                                to="/"
                                style={{
                                    textDecoration: 'none',
                                    display: 'inline-block',
                                }}
                            >
                                <Box
                                    component="img"
                                    src="http://contractortestla.com/wp-content/uploads/2024/11/new_Logo-small-transparent-3.png"
                                    alt="Contractor Test LA Logo"
                                    sx={{
                                        height: 100,
                                        transition: 'transform 0.3s',
                                        '&:hover': { transform: 'scale(1.05)' },
                                    }}
                                />
                            </Link>
                            <Typography sx={{ color: '#fff', mt: 2, mb: 3 }}>
                                For the past 31 years we have served over 30,000
                                successful contractors!
                            </Typography>

                            <Typography
                                variant="h5"
                                sx={{ fontWeight: 'bold', color: '#fff', mb: 2 }}
                            >
                                Quick Links
                            </Typography>
                            <Link
                                component={RouterLink}
                                to="/guarantee"
                                color="#fff"
                                sx={{
                                    display: 'flex',
                                    gap: 1,
                                    mb: 2,
                                    alignItems: 'center',
                                    color: '#ffffff90',
                                    textDecoration: 'none',
                                    '&:hover': {
                                        color: '#ff5e1c',
                                        transition: '0.3s',
                                    },
                                }}
                            >
                                <VerifiedIcon sx={{ fontSize: 18 }} />
                                <Typography sx={{ fontWeight: 500 }}>
                                    No Pass No Pay Guarantee
                                </Typography>
                            </Link>
                        </Box>

                        <Box
                            sx={{
                                flex: 1,
                                m: 1,
                                p: 2,
                            }}
                        >
                            <Typography
                                variant="h5"
                                sx={{ fontWeight: 'bold', color: '#fff', mb: 2 }}
                            >
                                Popular Tests
                            </Typography>
                            <Link
                                href="https://app.contractortestla.com/shop"
                                color="#fff"
                                sx={{
                                    display: 'flex',
                                    gap: 1,
                                    mt: 2,
                                    alignItems: 'center',
                                    color: '#ffffff90',
                                    textDecoration: 'none',
                                    '&:hover': {
                                        color: '#ff5e1c',
                                        transition: '0.3s',
                                    },
                                }}
                                target="_blank"
                            >
                                <Typography>
                                    Building Construction Commercial
                                </Typography>
                            </Link>
                            <Link
                                href="https://app.contractortestla.com/shop/"
                                color="#fff"
                                sx={{
                                    display: 'flex',
                                    gap: 1,
                                    mt: 2,
                                    alignItems: 'center',
                                    color: '#ffffff90',
                                    textDecoration: 'none',
                                    '&:hover': {
                                        color: '#ff5e1c',
                                        transition: '0.3s',
                                    },
                                }}
                                target="_blank"
                            >
                                <Typography>
                                    Electrical Work State Wide
                                </Typography>
                            </Link>
                            <Link
                                href="https://app.contractortestla.com/shop/"
                                color="#fff"
                                sx={{
                                    display: 'flex',
                                    gap: 1,
                                    mt: 2,
                                    alignItems: 'center',
                                    color: '#ffffff90',
                                    textDecoration: 'none',
                                    '&:hover': {
                                        color: '#ff5e1c',
                                        transition: '0.3s',
                                    },
                                }}
                                target="_blank"
                            >
                                <Typography>
                                    Residential Construction
                                </Typography>
                            </Link>
                            <Link
                                href="https://app.contractortestla.com/shop"
                                color="#fff"
                                sx={{
                                    display: 'flex',
                                    gap: 1,
                                    mt: 2,
                                    alignItems: 'center',
                                    color: '#ffffff90',
                                    textDecoration: 'none',
                                    '&:hover': {
                                        color: '#ff5e1c',
                                        transition: '0.3s',
                                    },
                                }}
                                target="_blank"
                            >
                                <Typography>Heavy Construction</Typography>
                            </Link>
                            <Link
                                href="https://app.contractortestla.com/shop"
                                color="#fff"
                                sx={{
                                    display: 'flex',
                                    gap: 1,
                                    mt: 2,
                                    alignItems: 'center',
                                    color: '#ffffff90',
                                    textDecoration: 'none',
                                    '&:hover': {
                                        color: '#ff5e1c',
                                        transition: '0.3s',
                                    },
                                }}
                                target="_blank"
                            >
                                <Typography>Hwy, Streets, Bridges</Typography>
                            </Link>
                        </Box>
                        <Box
                            sx={{
                                flex: 1,
                                m: 1,
                                p: 2,
                                borderRadius: 1,
                            }}
                        >
                            <Typography
                                variant="h5"
                                sx={{ fontWeight: 'bold', color: '#fff' }}
                            >
                                Contact Us
                            </Typography>
                            <Link
                                href="https://www.google.com/maps/place/Louisiana+Contractors+Licensing+Service,+Inc./@30.426311,-91.053504,16z/data=!4m5!3m4!1s0x8626bb5416d5834d:0xa45fa3fe300cbbd8!8m2!3d30.4259527!4d-91.053823?hl=en"
                                target="_blank"
                                color="#fff"
                                sx={{
                                    display: 'flex',
                                    gap: 1,
                                    mt: 2,
                                    alignItems: 'center',
                                    color: '#ffffff90',
                                    textDecoration: 'none',
                                    '&:hover': {
                                        color: '#ff5e1c',
                                        transition: '0.3s',
                                    },
                                }}
                            >
                                <LocationOnIcon
                                    sx={{
                                        mr: 1,
                                    }}
                                />
                                <Typography>
                                    2834 S. Sherwood Forest Blvd.Suite D-2 Baton
                                    Rouge La. 70816
                                </Typography>
                            </Link>
                            <Link
                                href="tel:+1-800-432-9930"
                                color="#fff"
                                sx={{
                                    display: 'flex',
                                    gap: 1,
                                    mt: 2,
                                    alignItems: 'center',
                                    color: '#ffffff90',
                                    textDecoration: 'none',
                                    '&:hover': {
                                        color: '#ff5e1c',
                                        transition: '0.3s',
                                    },
                                }}
                            >
                                <PhoneIcon
                                    sx={{
                                        mr: 1,
                                    }}
                                />
                                <Typography>1-800-432-9930</Typography>
                            </Link>
                            <Link
                                href="tel:+1-225-293-8107"
                                color="#fff"
                                sx={{
                                    display: 'flex',
                                    gap: 1,
                                    mt: 2,
                                    alignItems: 'center',
                                    color: '#ffffff90',
                                    textDecoration: 'none',
                                    '&:hover': {
                                        color: '#ff5e1c',
                                        transition: '0.3s',
                                    },
                                }}
                            >
                                <PhoneIcon
                                    sx={{
                                        mr: 1,
                                    }}
                                />
                                <Typography>225-293-8107</Typography>
                            </Link>
                            <Link
                                href="mailto:info@contractortestla.com"
                                color="#fff"
                                sx={{
                                    display: 'flex',
                                    gap: 1,
                                    mt: 2,
                                    alignItems: 'center',
                                    color: '#ffffff90',
                                    textDecoration: 'none',
                                    '&:hover': {
                                        color: '#ff5e1c',
                                        transition: '0.3s',
                                    },
                                }}
                            >
                                <EmailIcon
                                    sx={{
                                        mr: 1,
                                    }}
                                />
                                <Typography>
                                    info@contractortestla.com
                                </Typography>
                            </Link>
                        </Box>
                    </Box>
                </Container>
                <Box
                    sx={{
                        borderTop: '1px solid #e4e4e4',
                        mt: 3,
                    }}
                >
                    <Typography
                        sx={{
                            textAlign: 'center',
                            py: 2,
                            color: '#ffffff90',
                        }}
                    >
                        ©{new Date().getFullYear()} Louisiana Contractors
                        Licensing Services. All Rights Reserved. Study Program
                        Developed by{' '}
                        <Link
                            sx={{
                                color: '#ffffff90',
                                textDecoration: 'none',
                                '&:hover': {
                                    color: '#ff5e1c',
                                    transition: '0.3s',
                                },
                            }}
                            href="https://metroitmedia.com"
                            target="_blank"
                        >
                            {' '}
                            Metroit Media
                        </Link>
                    </Typography>
                </Box>
            </footer>
        </>
    );
}
